import { useNavigationPaneContext } from '@website-editor/context/NavigationPaneContext/NavigationPane.context';
import { PHOTO_ANIMATION_CONFIG, PHOTO_SCREENS } from '../Photo.constants';
import { useEffect } from 'react';
import { PhotoProps } from '../Photo';
import { getPhotoNavigations } from '../Photo.navigations';

/**
 * Add photo left panel navigation animation configs
 */
export const useAddPhototNavigations = (props: PhotoProps) => {
  const { screens, addNavigations } = useNavigationPaneContext();
  const photoNavigations = getPhotoNavigations({ ...props });
  useEffect(() => {
    if (!screens.includes(PHOTO_SCREENS[0])) {
      addNavigations(PHOTO_SCREENS, PHOTO_ANIMATION_CONFIG, photoNavigations);
    }
  }, [addNavigations, screens, photoNavigations]);
};
